import React from 'react'
import DateHelper from '../../../../utils/DateHelper'

const toDisplayDate = (date) => DateHelper.convertUTCtoDateTime(date ? new Date(date).toISOString() : null)

export const formatReportDuration = (statementData, startDate, endDate) => {
    const dateFilter = statementData?.queryData?.dateFilter
    const range = dateFilter ? DateHelper.getDateFilterRange(dateFilter) : { startDate, endDate }
    return `From ${toDisplayDate(range.startDate)} to ${toDisplayDate(range.endDate)}`
}

const DurationHeader = ({ startDate, endDate, statementData }) => {
    return (
        <div className="Duration_Header py-2">
            <div className='d-flex align-items-center gap-2 left_section'>
                <p className="sub_heading black">
                    Duration:
                </p>
                <p className='sub_heading fw-normal black'>
                    {formatReportDuration(statementData, startDate, endDate)}
                </p>
            </div>
            
        </div>
    )
}

export default DurationHeader
